export const STORY_BUILDER_CONTAINER = 'story-builder-container';
